import {ChangeDetectionStrategy, Component, HostBinding, inject, input, Input, OnInit} from '@angular/core';
import {Food, Maybe, Rating, WineProduct} from '@core/interfaces/generated/graphql';
import {Observable} from 'rxjs';
import {StoryblokDirective} from '@core/directives/storyblok.directive';
import {AsyncPipe, NgOptimizedImage} from '@angular/common';
import {StoryblokBaseComponent} from '../storyblok-base.component';
import {ProductService} from '@core/services/product.service';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {StoryblokService} from '@core/services/storyblok.service';
import {RoutingService} from '@core/services/routing.service';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {
  ProductCompactRatingPointsComponent
} from '@layout/components/product/product-compact-rating/product-compact-rating-points/product-compact-rating-points.component';

@Component({
  selector: 'app-storyblok-product-card',
  templateUrl: './storyblok-product-card.component.html',
  styleUrls: ['./storyblok-product-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, AsyncPipe, NgOptimizedImage, FontAwesomeModule, ProductCompactRatingPointsComponent]
})
export class StoryblokProductCardComponent extends StoryblokBaseComponent implements OnInit {
  productService = inject(ProductService);
  private storyblokService = inject(StoryblokService);
  private routingService = inject(RoutingService);
  private storyblokStylingService = inject(StoryblokStylingService);

  readonly vismaId = input.required<string>();
  readonly _editable = input<any>();
  readonly general_styling = input<any>();
  @HostBinding('attr.id') hostElementId: any;
  @HostBinding('class') class: any;

  product$: Observable<Maybe<WineProduct> | undefined>;
  productStoryblok$: Observable<any>

  @Input()
  set elementId(value: any) {
    this.hostElementId = value;
  }

  ngOnInit() {
    this.product$ = this.productService.getProductByVismaId(this.vismaId());
    this.productStoryblok$ = this.storyblokService.getStoryObservable('product', this.routingService.getQueryParams());
    this.class = this.getClass();
  }

  ratings(product: WineProduct): Rating[] {
    const ratings = product?.meta?.ratings;
    if (!ratings) {
      return [];
    }
    return ratings.filter(d => !!d).slice(0, 3) as Rating[];
  }

  getFoods(product: WineProduct): Food[] {
    return product?.meta?.foods?.filter(d => !!d).slice(0, 5) as Food[];
  }

  getClass(): string[] {
    return this.storyblokStylingService.getClassList(this.general_styling(), undefined, {'col-': 12});
  }

  getIcon(item: string | null): string | undefined {
    return this.productService.getItemIcon(item);
  }
}
